const advertise = {
  dfdh: 'Telefone do outro usuário:',
  sjmc: 'Nome do Vendedor',
  qsrsj: 'Digite o nome do vendedor',
  sjbzj: 'Depósito do Vendedor',
  wcl: 'Taxa de Conclusão em 30 Dias',
  zcd: 'Total de Pedidos (Compra/Venda)',
  cd: 'Pedidos em 30 Dias',
  c: 'vezes',
  fz: 'minutos',
  pjfx: 'Tempo Médio de Liberação',
  zcsj: 'Data de Registro:',
  fbjy: 'Primeira Vez para Acessar a Negociação Fiat:',
  yxbd: 'E-mail Verificado',
  sjbd: 'Celular Verificado',
  cjsm: 'Verificação Inicial de Identidade',
  gjsm: 'Verificação Avançada de Identidade',
  buy: 'Comprar',
  sell: 'Vender',
  market: 'Mercado',
  djfs: 'Método de Precificação',
  ggid: 'ID do Anúncio',
  time: 'Horário',
  type: 'Tipo',
  ptgg: 'Anúncio Padrão',
  gdjg: 'Preço Fixo',
  fdjg: 'Preço Flutuante',
  yjfw: 'Margem de Lucro',
  unitPrice: 'Preço Unitário',
  totalPrice: 'Preço Total',
  sysl: 'Quantidade Restante',
  ywcsl: 'Quantidade Concluída',
  cz: 'Ação',
  xj: 'Retirar do Anúncio',
  sj: 'Publicar Anúncio',
  edit: 'Editar',
  delete: 'Excluir',
  all: 'Todos',
  qdxjm: 'Tem certeza de que deseja retirar este anúncio?',
  qdxj: 'Confirmar Retirada',
  qdsjm: 'Tem certeza de que deseja publicar este anúncio?',
  qdsj: 'Confirmar Publicação',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  qdscm: 'Tem certeza de que deseja excluir este anúncio?',
  deleteAdvertise: 'Excluir Anúncio',

  tjgm: 'Estatísticas de Compra',
  tjcs: 'Estatísticas de Venda',
  coins: 'Moeda',
  day7: '7 Dias',
  day15: '15 Dias',
  day30: '30 Dias',
  tj: 'Estatísticas',
  mrsl: 'Quantidade Comprada',
  mcsl: 'Quantidade Vendida',
  mrjj: 'Preço Médio de Compra',
  mcjj: 'Preço Médio de Venda',
  zcje: 'Valor Gasto',
  srje: 'Valor Recebido',
  zsxf: 'Taxa Total de Transação',
  cjdd: 'Pedidos Concluídos',
  zdxx: 'Informações do Pedido',
  tips: 'Dica: Para cada par de negociação, você pode exportar estatísticas de compra e venda apenas 100 vezes por dia.',
  dcdd: 'Exportar Pedidos',
  orderNo: 'Número do Pedido',
  jybz: 'Par de Negociação',
  number: 'Quantidade',
  total: 'Total',
  fee: 'Taxa',
  zd: 'Detalhes',

  tjskfs: 'Adicionar Método de Recebimento',
  skfs: 'Método de Recebimento',
  name: 'Nome',
  payAccount: 'Conta',
  sk: 'Receber',
  cz: 'Ação',
  delete: 'Excluir',
  edit: 'Editar',
  qdsc: 'Confirmar Exclusão?',
  tip: 'Dica',
  deleted: 'Exclusão Cancelada',
  xzskfstt: 'Novo Método de Recebimento',
  xgskfstt: 'Editar Método de Recebimento',
  khmc: 'Nome do Beneficiário',
  yhkh: 'Número da Conta Bancária',
  khh: 'Nome do Banco',
  khhszd: 'Local do Banco',
  khhmc: 'Nome da Agência do Banco',
  wxzh: 'Conta WeChat',
  zfbzf: 'Conta Alipay',
  ewmsc: 'Carregar Código QR',
  jymm: 'Senha de Negociação',
  srkhh: 'Digite o nome do banco',
  xzszd: 'Selecione o local do banco',
  srkhmc: 'Digite o nome da agência do banco',
  srzh: 'Digite o número da conta',
  scskm: 'Carregue o Código QR',
  srjymm: 'Digite a senha de negociação',
  scwjgd: 'O tamanho da imagem não pode exceder 2MB!',

  jnbzj1: 'Como {gradeName}, você já depositou {margin} USDT como garantia e tem um limite de anúncios remanescente de {amount} USDT.',
  k: 'Disponível',
  add: 'Adicionar',
  or: 'ou',
  reduce: 'Reduzir',
  margin: 'Garantia',
  sqsxf: '*A plataforma cobra uma taxa de {fee}% do valor total das transações concluídas como taxa de serviço.',
  hqed: 'Torne-se um negociante verificado para obter limites mais altos',
  want: 'Eu quero',
  bb: 'Negociar',
  price: 'Preço',
  ckj: '*Preço de referência do mercado {price} {fiatCurrency}/USDT. O preço fixo não muda com a oscilação do mercado.',
  jyjg: 'Preço da Negociação',
  mdjg: 'Preço Ancorado',
  gxhl: '*Taxa de câmbio em tempo real de vários bancos e corretoras. Atualizada a cada 5 minutos.',
  szyj: 'Definir Margem de Lucro',
  zjjy: '*Insira um número negativo para oferecer um desconto no preço base.',
  yjsz: '*Preço de Negociação = Preço Ancorado * (1 + Margem de Lucro Definida)',
  jyxz: 'Restrições de Negociação',
  jysl: 'Quantidade de Negociação',
  sygged: '*A quantidade de negociação não pode exceder o limite de anúncios remanescente.',
  zxxe: 'Limite Mínimo por Transação',
  zdxe: 'Limite Máximo por Transação',
  fkqx: 'Prazo para Pagamento',
  xnfk: '*O pagamento deve ser concluído dentro deste prazo.',
  fkfs: 'Método de Pagamento',
  xzskfs: '*Você pode adicionar até 5 métodos de recebimento para todas as moedas.',
  yhjy: 'Não negociar com usuários que não concluíram a verificação de identidade avançada.',
  jygg: '*Usuários que concluíram apenas a verificação de identidade inicial não podem acessar os anúncios de negociação.',
  cyjy: 'Escolher apenas usuários que não completaram um número específico de transações de compra. ',
  bmfx: '*Acessar apenas usuários que fizeram compras no passado reduz significativamente o risco de origem desconhecida dos fundos.',
  qxz: 'Selecione',
  jybz: 'Observações da Negociação',
  tyzs: 'Eu entendo e concordo em seguir as',
  jygz: 'Regras da Negociação',
  yzm: 'Código de Verificação',
  save: 'Salvar',
  fbgg: 'Publicar Anúncio',
  jsbzjcg: 'Redução de Garantia Bem-sucedida',
  zjbzjcg: 'Adição de Garantia Bem-sucedida',
  xzfs: 'Selecione o Método de Recebimento ou Pagamento',
  bankTip1: 'Você não pode adicionar mais de três métodos de recebimento bancário.',
  wxTip2: 'Você não pode adicionar mais de três contas WeChat.',
  zfbTip3: 'Você não pode adicionar mais de três contas Alipay.',
  syjg: 'Por favor, insira o preço.',
  syjysl: 'Por favor, insira a quantidade de negociação.',
  zxxe: 'Por favor, insira o limite mínimo por transação.',
  zdxe: 'Por favor, insira o limite máximo por transação.',
  fkqx: 'Por favor, insira o prazo para pagamento.',
  tyjygz: 'Por favor, aceite as regras de negociação.',
  tpyzm: 'Por favor, insira o código de verificação da imagem.',
  jydx: 'Usuário para Negociação',

  zjbzj: 'Adicionar Garantia',
  jsbzj: 'Reduzir Garantia',
  xzdgged: 'Limite Atual de Anúncios',
  zjbzjse: 'Valor de Garantia para Adicionar',
  jsbzjse: 'Valor de Garantia para Reduzir',
  zjhbzjed: 'Saldo de Garantia após Adição',
  jshbzjed: 'Saldo de Garantia após Redução',
  balance: 'Saldo',
  sy: 'Disponível',
  kzj: 'Pode Adicionar',
  kjs: 'Pode Reduzir',
  otcsjxy: 'Regras do Serviço de Negociação de Usuários OTC',
  xsgz: 'Tutorial para Iniciantes',
  jygz: 'Regras da Negociação',
  jnbzj: 'Para garantir a legalidade e a conformidade das negociações OTC e padronizar as operações de todas as partes envolvidas, exigimos que os negociantes depositem uma determinada quantia como garantia.',
  zjjnbzj: 'A garantia é composta de duas partes: valor básico e valor adicional. O valor básico é obrigatório, e o valor adicional é opcional.',
  kxs: 'O depósito do valor básico permite que você tenha um limite de anúncio de',
  fbgged: 'anúncio(s) CNYT (calculados com base na taxa de câmbio).',
  ggedbl: 'A proporção entre o valor adicional de garantia e o limite de anúncio é',
  eg: 'por exemplo, se você adicionar 100 USDT, seu limite de anúncio aumentará em 100 x',
  ggzedjs: 'A fórmula para calcular o valor total do anúncio é: Valor Básico do Anúncio + Valor Adicional do Anúncio x',
  ttsjzxed: 'O valor mínimo de adição de garantia para negociantes comuns é',
  zdedw: ', e o valor máximo é',
  mgsjzd: 'Cada negociante pode publicar até três anúncios de compra e três anúncios de venda.',
  hljj: 'A taxa de câmbio USDT/CNYT é baseada no preço médio dos pares de negociação relacionados na plataforma BiKing (os dados são registrados a cada hora, excluindo o preço mais alto e o mais baixo). Quando a taxa de câmbio flutua, o valor dos anúncios existentes permanece inalterado.',
  jcbzj: 'Valor Básico de Garantia',
  xt: 'Opcional',
  njhded: 'O limite de anúncio que você obterá é:',
  mbye: 'Saldo de Compra:',
  zhzcbz: 'Saldo insuficiente na conta. Você pode transferir',
  qhz: 'Transferir Agora',
  qdjnbzj: 'Confirmar Depósito do Valor Básico de Garantia',
  tjbzj: 'Adicionar Garantia',
  sqsjcg: 'Pedido de Negociante Confirmado',
  exchange:'Trocar Taxa'
};

export {
  advertise
};



// WEBPACK FOOTER //
// ./src/i18n/lang/advertise/pt_BR.js